<script>
import Layout from '@layouts/default'

export default {
  page: {
    title: 'Buyback Protection Terms and Conditions | AutoCheck.com',
    meta: [
      {
        name: 'description',
        content: 'Buyback Protection Terms and Conditions',
      },
    ],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <div class="row mt-4">
      <div class="col-md-9 col-12">
        <table border="0" cellspacing="0" cellpadding="4" width="100%">
          <tbody>
            <!-- <tr><td><p align="CENTER"><img src="/medias/logo-autocheck.png?context=bWFzdGVyfGltYWdlc3w4Mjg3fGltYWdlL3BuZ3xpbWFnZXMvaDk0L2g5OC84Nzk3MTkxNDM4MzY2LnBuZ3wyMDc5ZDEyZGVlNmY0ZjVjNTI1Zjk0YjVmNmQwYWY1ZWNiYTZhYzE4Y2U1OTBjYTdhODU5ZTA5ODY5NjJhNzYx" _mce_src="/medias/logo-autocheck.png?context=bWFzdGVyfGltYWdlc3w4Mjg3fGltYWdlL3BuZ3xpbWFnZXMvaDk0L2g5OC84Nzk3MTkxNDM4MzY2LnBuZ3wyMDc5ZDEyZGVlNmY0ZjVjNTI1Zjk0YjVmNmQwYWY1ZWNiYTZhYzE4Y2U1OTBjYTdhODU5ZTA5ODY5NjJhNzYx" alt="" width="195" height="48" border="0" /></p></td> -->

            <tr>
              <td><h1>Buyback Protection Terms and Conditions</h1></td>
            </tr>

            <tr align="left">
              <td
                >Subject to the following, Experian agrees to pay the Customer
                the Customer's purchase price of the Vehicle if: <br /><br />A.
                the AutoCheck Vehicle History Report was provided prior to the
                purchase of the Vehicle and on or after June 27, 2005; and
                <br /><br />B. the AutoCheck Vehicle History Report reflects no
                Branded Titles or other major issues as part of the Vehicle
                Title history, but a Branded Title actually exists.</td
              >
            </tr>

            <tr align="left">
              <td
                ><b>DEFINITIONS </b><br />1a. Branded Title - is a vehicle
                ownership or registration document issued by any of the 50
                states of the U.S. (or the District of Columbia), issued with
                words or symbols signifying that the vehicle was: junked or
                salvaged; dismantled, rebuilt or reconstructed; flood damaged;
                fire damaged; hail damaged; bought back by its manufacturer
                ("Lemon Law" vehicle); odometer exceeds mechanical limits;
                odometer was not actual mileage; or which was issued with any
                other symbol or word signifying a substantially similar
                brand.<br /><br />1b. Excluded Brands - Specifically excluded
                from the definition of Branded Title are: ownership and
                registration documents originally issued without a brand but
                later stamped with a brand without being reissued; salvage
                titles issued due to theft; damage disclosure documents; and
                Branded Titles issued in error and later corrected. Other
                information that may reflect negatively on the vehicle,
                including but not limited to accident information, is excluded
                from AutoCheck Buyback Protection unless expressly covered by
                the definition of "Branded Title".<br /><br />2. Consumer - the
                person (other than a Dealer or Transferee) who ordered and paid
                for the Report prior to their purchase of the Vehicle.<br /><br />3.
                Customer - a Consumer, or any licensed automobile dealer
                ("Dealer") who ordered and paid for the Report through an
                AutoCheck Commercial Service ("Commercial Service" is any site
                geared solely for dealers or other commercial users, such as
                AutoCheckmembers.com, either accessed directly or through a
                partner, and AutoCheck Express) or the Transferee of any such
                Dealer.<br /><br />4. Report/AutoCheck Report - AutoCheck
                Vehicle History Report.<br /><br />5. Transferee - the purchaser
                of the Vehicle from the Dealer.<br /><br />6. Vehicle - the
                passenger vehicle or light truck to which the Report
                relates.</td
              >
            </tr>

            <tr align="left">
              <td
                ><b>TERMS AND CONDITIONS</b> <br />
                <table border="0" cellspacing="4" cellpadding="4" width="100%">
                  <tbody>
                    <tr>
                      <td width="50%" style="vertical-align: top;"
                        >1. The Customer must have previously purchased the
                        Vehicle and own the Vehicle at the time the claim is
                        made. If the Vehicle is subject to a lien in an unpaid
                        amount greater than the amount identified in item 8,
                        this Protection only applies if the Customer pays
                        Experian the difference.<br /><br />2. The Customer must
                        complete and submit to Experian an executed claim form
                        and provide a complete copy of the Report. Any Dealer
                        Customer must have obtained the Report through an
                        AutoCheck Commercial Service prior to the purchase of
                        the Vehicle. <br /><br />3. The Customer must provide to
                        Experian proof of ownership of the Vehicle in the form
                        of the original bill of sale and a current vehicle
                        ownership document issued to the Customer by the motor
                        vehicle agency of one of the 50 states of the United
                        States or the District of Columbia.<br /><br />4. The
                        Customer must provide to Experian a copy of the front
                        and back of the Branded Title, certified by the issuing
                        state authority. The Branded Title must have been issued
                        at least sixty (60) days prior to the date the Report
                        was run. <br /><br />5. The Customer must deliver to
                        Experian all ownership and registration documentation
                        including, the certificate of title and certificate of
                        registration, properly assigned by the Customer to
                        Experian so Experian becomes the owner of the
                        Vehicle.<br /><br />6. If, prior to purchasing the
                        Vehicle, the Customer knew, or had evidence, of the
                        existence of a Branded Title for the Vehicle, the
                        Protection does not apply.<br /><br />7. Experian will
                        pay a maximum of the purchase price of the Vehicle paid
                        by the Customer (plus warranties and other additional
                        purchases such as installed aftermarket accessories, not
                        exceeding a total of $500).<br /><br />8. If the
                        purchase price of the Vehicle in item 7 exceeds the NADA
                        Used Car Guides used vehicle retail value at the time of
                        the sale, Experian will pay no more than ten percent
                        (10%) over the NADA Used Car Guides used vehicle retail
                        value at the time the Customer purchased the Vehicle.<br /><br />9.
                        The Buyback Protection will apply only if the Vehicle
                        was manufactured in model year 1981 or later.<br /><br />10.
                        The Buyback Protection will expire the earlier of (a)
                        the date the Customer sells the Vehicle or (b) one (1)
                        year after the date of the first Report run by or for
                        the Customer relating to the Vehicle.</td
                      >
                      <td width="50%" style="vertical-align: top;"
                        >11. This Buyback Protection is deemed assigned to the
                        Transferee upon the sale of the Vehicle, provided that a
                        copy of the Report is given to the Transferee and the
                        Transferee registers in accordance with item 12.<br /><br />12.
                        In order for this Buyback Protection to be in effect for
                        Transferees or Consumers, they must register with
                        Experian within ninety (90) days of the date they
                        purchased the Vehicle. Registration may be made online
                        at
                        <BaseLink :to="{ name: 'login' }" target="_blank"
                          >www.autocheck.com/
                          vehiclehistory/my-account/buyback</BaseLink
                        >
                        or by writing Experian for a registration form and
                        submitting the same to Experian. The registration form
                        must be completed and submitted to: Buyback Protection
                        C/O Experian Automotive, 1515 E. Woodfield Road, Suite
                        500, Schaumburg, IL 60173. <br /><br />13. Claims can be
                        submitted to: Buyback Protection C/O Experian
                        Automotive, 1515 E. Woodfield Road, Suite 500,
                        Schaumburg, IL 60173. Please include name, address,
                        telephone number, email address, the Vehicle
                        Identification Number (VIN) of the Vehicle and a copy of
                        the original report. Claim forms can be obtained online
                        at
                        <BaseLink
                          :to="{
                            name: 'vehicle-buyback-protection',
                            hash: '#claim',
                          }"
                          target="_blank"
                          >www.autocheck.com/vehiclehistory/buyback-claim</BaseLink
                        >
                        or by writing to Experian at the address above.<br /><br />14.
                        Experian reserves the right to cancel the Buyback
                        Protection program at anytime, but pledges to honor all
                        current and future Buyback Protection claims as long as
                        they meet all of the Buyback Protection terms and
                        conditions stated herein and the Report was run prior to
                        Buyback Protection program cancellation.<br /><br />15.
                        Dealer Customers must use an AutoCheck Commercial
                        Service in order for their transferees to be eligible
                        for Buyback Protection. Because Dealer Customers are
                        prohibited from using the AutoCheck Consumer Web site,
                        they are not eligible for Buyback Protection if they
                        purchase from a Consumer Web site, and their subsequent
                        Transferees are not covered by Buyback Protection in
                        such instance.<br /><br />16. The Buyback Protection
                        will be governed by the laws of, and Customer consents
                        to the exclusive jurisdiction of the courts of, the
                        State of Illinois, United States of America.
                        <br /><br />17. In the case of a Branded Title that
                        satisfies the above, Customer represents, warrants and
                        agrees that Customer has not sought compensation from
                        any other party or entity for both the same Vehicle and
                        for the same title brand(s) that would -- together with
                        any remuneration received (or to be received) from
                        Experian -- exceed the fair market value of the
                        Vehicle.</td
                      >
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-3 col-12 mt-4 mb-4">
        <div
          class="content-page-right-navigation gray"
          :class="$style.learnMore"
          ><div class="cardContent"
            ><div class="text-center mb-3"
              ><img src="images/generic-buback-protection.png" border="0"
            /></div>
            <h4>Learn more about Buyback Protection:</h4>
            <ul>
              <li>
                <BaseLink
                  :to="{ name: 'vehicle-buyback-protection', hash: '#covered' }"
                  >What's Covered? »</BaseLink
                >
              </li>
              <li>
                <BaseLink
                  :to="{
                    name: 'vehicle-buyback-protection',
                    hash: '#protection',
                  }"
                  >What Makes Buyback Protection Different? »</BaseLink
                >
              </li>
              <li>
                <BaseLink
                  :to="{ name: 'vehicle-buyback-protection', hash: '#how' }"
                  >How Does Buyback Protection Work? »</BaseLink
                >
              </li>
              <li>
                <BaseLink
                  :to="{
                    name: 'vehicle-buyback-protection',
                    hash: '#register',
                  }"
                  >Register for Buyback Protection »</BaseLink
                >
              </li>
              <li>
                <BaseLink
                  :to="{ name: 'vehicle-buyback-protection', hash: '#claim' }"
                  >Make a Claim »</BaseLink
                >
              </li>
            </ul></div
          ></div
        >
        <div class="mt-4">
          <BaseLink
            :to="{ name: 'vehicle-buyback-protection', hash: '#searchVin' }"
          >
            <img class="w-80 m-auto d-block" src="images/ac-check-vin.png" />
          </BaseLink>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
